/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TokenModel } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class RefreshToken<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Auth
   * @name AuthGetRefreshToken
   * @request POST:/refresh-token
   * @secure
   */
  authGetRefreshToken = (params: RequestParams = {}) =>
    this.request<TokenModel, any>({
      path: `/refresh-token`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
}
